import { ArrowLeftCircleIcon } from './ArrowLeftCircleIcon';

/**
 * author: Austin Andrews
 * id 57F5D624-D5B0-4F19-AFAB-676F822C87DC
 * name arrow-left-circle
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-left-circle.svg
 * tags
 * - Arrow 
 */
export const ArrowBackCircleIcon = ArrowLeftCircleIcon;
export default ArrowBackCircleIcon